 [
    {
      "id": 1,
      "title": "г. Якутск, Республика Саха",
      "status": "",
      "type": "",
      "location": "129.732178, 62.027221",
      "image": "",
      "links": [
        {
          "text": "Академия наук Республики Саха (Якутия)",
          "address": "https://hightech.fm/2022/11/28/science-extreme-statistic"
        },
        {
          "text": "Северо-Восточный федеральный университет имени М. К. Аммосова",
          "address": "https://hightech.fm/2022/11/28/ice-zone-science"
        },
        {
          "text": "Институт проблем нефти и газа СО РАН",
          "address": "https://hightech.fm/2022/11/28/ice-zone-science"
        },
        {
          "text": "Институт геологии алмаза и благородных металлов СО РАН",
          "address": "https://hightech.fm/2022/11/28/science-extreme-statistic"
        },
        {
          "text": "Институт мерзлотоведения имени П. И. Мельникова СО РАН",
          "address": "https://hightech.fm/2022/11/28/science-extreme-statistic"
        },
        {
          "text": "Якутский научный центр СО РАН",
          "address": "https://hightech.fm/2022/11/28/north-science-energy"
        }
      ],
      "places" : [
       {
         "text": "Институт прикладной экологии Севера"
       },
        {
          "text": "Якутский научный центр комплексных медицинских проблем"
        },
        {
          "text": "Арктический научно-исследовательский центр Республики Саха (Якутия)"
        },
        {
          "text": "Якутский проектный научно-исследовательский институт строительства"
        },
        {
          "text": "Арктический государственный агротехнологический университет"
        }
      ],
      "info": "",

      "created": ""
    },
    {
      "id": 2,
      "title": "г. Магадан",
      "status": "",
      "type": "",
      "location": "150.808586, 59.565155",
      "image": "",
      "links": [
        {
          "text": "",
          "address": ""
        }
      ],
      "places" : [
        {
          "text": "Научно-исследовательский центр Арктика ДВО РАН"
        },
        {
          "text": "Институт биологических проблем Севера ДВО РАН"
        },
        {
          "text": "Северо-Восточный комплексный научно-исследовательский институт им. Н. А. Шило ДВО РАН"
        },
        {
          "text": "Северо-Восточный государственный университет"
        }
      ],
      "info": "",

      "created": ""
    },
   {
     "id": 3,
     "title": "г. Мирный",
     "status": "",
     "type": "",
     "location": "113.978701, 62.541028",
     "image": "",
     "links": [
       {
         "text": "",
         "address": ""
       }
     ],
     "places" : [
       {
         "text": "Научно-исследовательское геологическое предприятие АК «Алроса»"
       },
       {
         "text": "Северо-Восточный федеральный университет имени М. К. Аммосова"
       },
       {
         "text": "Политехнический институт (филиал) СВФУ в г. Мирном"
       }
     ],
     "info": "",

     "created": ""
   },
   {
     "id": 4,
     "title": "г. Южно-Сахалинск",
     "status": "",
     "type": "",
     "location": "142.729587, 46.957771",
     "image": "",
     "links": [
       {
         "text": "Сахалинский государственный университет",
         "address": "https://hightech.fm/2022/11/28/north-science-energy"
       }
     ],
     "places" : [
       {
         "text": "Специальное конструкторское бюро средств автоматизации морских исследований ДВО РАН"
       }
     ],
     "info": "",

     "created": ""
   },
   {
     "id": 5,
     "title": "г. Нерюнгри",
     "status": "",
     "type": "",
     "location": "124.712311, 56.657717",
     "image": "",
     "links": [
       {
         "text": "",
         "address": ""
       }
     ],
     "places" : [
       {
         "text": "Технический институт (филиал) СВФУ в г. Нерюнгри"
       }
     ],
     "info": "",

     "created": ""
   },
   {
     "id": 6,
     "title": "г. Петропавловск-Камчатский",
     "status": "",
     "type": "",
     "location": "158.643503, 53.024265",
     "image": "",
     "links": [
       {
         "text": "",
         "address": ""
       }
     ],
     "places" : [
       {
         "text": "Камчатский государственный университет имени Витуса Беринга"
       }
     ],
     "info": "",

     "created": ""
   },
   {
     "id": 7,
     "title": "г. Анадырь",
     "status": "",
     "type": "",
     "location": "177.518913, 64.735814",
     "image": "",
     "links": [
       {
         "text": "",
         "address": ""
       }
     ],
     "places" : [
       {
         "text": "Чукотский филиал Северо-Восточного федерального университета им. М.К. Аммосова"
       }
     ],
     "info": "",

     "created": ""
   },
   {
   "id": 8,
   "title": "г. Москва",
   "status": "",
   "type": "",
   "location": "37.617644, 55.755819",
   "image": "",
   "links": [
     {
       "text": "",
       "address": ""
     }
   ],
   "places" : [
       {
         "text": "Московский государственный технический университет им. Н. Э. Баумана"
       }
     ],
   "info": "",

   "created": ""
 },
   {
   "id": 9,
   "title": "г. Новосибирск",
   "status": "",
   "type": "",
   "location": "82.920430, 55.030204",
   "image": "",
   "links": [
     {
       "text": "",
       "address": ""
     }
   ],
   "places" : [
       {
         "text": "Федеральный исследовательский центр Институт цитологии и генетики СО РАН"
       },
       {
         "text": "Институт геологии и минералогии им. В.С. Соболева"
       },
       {
         "text": "Институт теоретической и прикладной механики им. С.А. Христиановича СО РАН"
       },
       {
         "text": "Институт химии твердого тела и механохимии СО РАН"
       },
       {
         "text": "Институт нефтегазовой геологии и геофизики им. А. А. Трофимука СО РАН"
       }
     ],
   "info": "",

   "created": ""
 },
   {
   "id": 10,
   "title": "г. Черноголовка",
   "status": "",
   "type": "",
   "location": "38.378248, 56.009849",
   "image": "",
   "links": [
     {
       "text": "",
       "address": ""
     }
   ],
   "places" : [
       {
         "text": "Институт проблем химической физики и медицинской химии РАН"
       }
     ],
   "info": "",

   "created": ""
 },
   {
   "id": 11,
   "title": "г. Санкт-Петербург",
   "status": "",
   "type": "",
   "location": "30.315877, 59.939099",
   "image": "",
   "links": [
     {
       "text": "",
       "address": ""
     }
   ],
   "places" : [
       {
         "text": "Крыловский государственный научный центр"
       },
       {
         "text": "Физико-технический институт им. А. Ф. Иоффе Российской академии наук"
       }
     ],
   "info": "",

   "created": ""
 }
 ]
